import { load } from '@cashfreepayments/cashfree-js';

const mode = process.env.REACT_APP_CASHFREE_MODE === 'production' ? 'production' : 'sandbox';
console.log('CASHFREE_MODE:', mode);
export const cashfree = await load({ mode });

export const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');
